import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, ListViewComponent, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { Serie } from './serie';
import { SeriesResponse } from './seriesresponse';

@Component({
    selector: 'app-series',
    templateUrl: './series.component.html',
    styleUrls: ['./series.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, FormsModule, RouterModule, ListViewComponent, ListViewComponent, TranslationPipe]
})
export class SeriesComponent implements OnInit {
    filteredSeries: Serie[] = [];

    getSeriesUrl = '/admin/get-series';

    searchText = '';

    serieList: Serie[] = [];

    seriesResponse: SeriesResponse = {};

    storeBaseUrl = '';

    constructor(
        private _router: Router,
        private _toastMessageService: ToastmessageService,
        private _translateService: TranslationService,
        @Inject('STORE_BACKEND_URL') private _storeBeUrl: string,
        private _apiRequestService: ApiRequestService
    ) {
        this.storeBaseUrl = _storeBeUrl;
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this._apiRequestService
                .sendRequest<{}, SeriesResponse>(this.storeBaseUrl, {}, true, this.getSeriesUrl)
                .subscribe((response) => {
                    this.serieList = response.serieList!;
                    this.filteredSeries = this.serieList;
                });
        } else {
            this._router.navigateByUrl('/');
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }
}
